/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainStoreStoreProductLabels
 */
export interface FxIdDomainStoreStoreProductLabels {
    /**
     * 
     * @type {Array<string>}
     * @memberof FxIdDomainStoreStoreProductLabels
     */
    Labels: Array<string>;
}

/**
 * Check if a given object implements the FxIdDomainStoreStoreProductLabels interface.
 */
export function instanceOfFxIdDomainStoreStoreProductLabels(value: object): value is FxIdDomainStoreStoreProductLabels {
    if (!('Labels' in value) || value['Labels'] === undefined) return false;
    return true;
}

export function FxIdDomainStoreStoreProductLabelsFromJSON(json: any): FxIdDomainStoreStoreProductLabels {
    return FxIdDomainStoreStoreProductLabelsFromJSONTyped(json, false);
}

export function FxIdDomainStoreStoreProductLabelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainStoreStoreProductLabels {
    if (json == null) {
        return json;
    }
    return {
        
        'Labels': json['Labels'],
    };
}

export function FxIdDomainStoreStoreProductLabelsToJSON(json: any): FxIdDomainStoreStoreProductLabels {
    return FxIdDomainStoreStoreProductLabelsToJSONTyped(json, false);
}

export function FxIdDomainStoreStoreProductLabelsToJSONTyped(value?: FxIdDomainStoreStoreProductLabels | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Labels': value['Labels'],
    };
}

